<template>
    <div class="header-apr">
        <HeadDetailsGama :titleHead="'Retornar Listagem'" :buttontemplate="true" :buttonbackCustom="true" style="font-family: 'Segoe UI';"></HeadDetailsGama>
        <Tables ref="tableSignatureQma"
            :columns="colunas"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            :newHeaderStatus="true"
            :showHeader="false"
            v-on:Load="onLoad"
            style="font-family: 'Segoe UI';">
            <tr v-for="(obj, index) in dataSignature" :key="index">
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.cargo"></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.nomeAssinatura"></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.dataAssinaturaFormatadaDia"></TableColumn>
                <TableColumn :IsDocumentActions="true"
                    :HasDownload="false"
                    :HasDetails="true"
                    :HasDocumentDelete="false"
                    style="justify-content: center ;display: flex;"
                    v-on:Details="openPopUpSignature(obj)"
                ></TableColumn>
            </tr>
        </Tables>
        <b-modal ref="assinatura-render"
            size="lg"
            centered
            id="assinatura-renderId"
            title="Visualizar Assinatura"
            :hide-footer="true"
            :clickToClose="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            hide-header-close
            body-class="rounded-bottom-1rem "
            content-class="rounded-1rem"
            >
            <template #modal-title="{ close }">
                  <div class="header w-100">
                    <div class="titulo-modal">Visualizar Assinatura</div>
                    <div class="button-modal d-flex">
                      <div class="ml-3 mr-3 closepoup" @click="close()"><i class="fa fa-times"></i></div>
                    </div>
                  </div>
                </template>
              <div class="infoSingature p-3">
                <div v-if="IsExterno === false && detalhes.status == 1" class="edit-save">
                  <div v-if="IsExterno === false" @click="clickEdit" class="mb-3 btn-edit" style="cursor: pointer;">
                    <i class="fas fa-edit ml-3 mr-2" style="cursor: pointer;" v-b-tooltip.hover title="Editar Informações">
                    </i>
                    Editar
                  </div>
                  <div class="btn-header">
                    <div class="btn-appr-rep mr-3">
                      <button :disabled="!isEdit" :class="isEdit === true ? 'btn-appr-popup' : 'btn-appr-popup-disabled'" @click="verificaCamposEdit"><i class="fas fa-save mr-2"></i>SALVAR</button>
                    </div>
                  </div>
                </div>
              <div class="d-flex">
                <div class="docSignature w-50 ml-3 mr-3">
                  <div class="font-title"> {{ detalhes.externo === false ? "Matricúla" : "Documento"}}</div>
                  <div class="d-flex align-items-center">
                    <autocomplete-z
                      v-if="isEdit == true && !IsExterno"
                      ref="responsavelTypeahead"
                      placeholder="Informe a matricula do funcionário"
                      type="text"
                      :serializer="(responsavel) => responsavel.code"
                      :formField="form.ResponsavelId"
                      v-on:changeCode="onChangeCodeResponsavel"
                      :ShowInput="false"
                      @change="getInput"
                      />
                    <div v-if="detalhes.matricula == null " class="font-title mr-2"> {{ detalhes.documento == 1 ? "CPF" : "RG"}}</div>
                    <b-input
                    v-if="isEdit === false && IsExterno === false"
                    disabled
                    :style="isEdit === false ? 'cursor: not-allowed; background-color: #ebebeb; color: grey' : 'cursor: auto'"
                    v-model="detalhes.matricula"></b-input>
                    <b-input
                    v-if="isEdit === false && IsExterno === true"
                    :disabled="isEdit === false && IsExterno === true"
                    :style="isEdit === false ? 'cursor: not-allowed; background-color: #ebebeb; color: grey' : 'cursor: auto'"
                    :maxlength="detalhes.documento == 1 ? 11 : 9 "
                    v-model="detalhes.documentoAssinatura"></b-input>
                  </div>
                </div>
                <div class="nameSignature w-50 ml-3 mr-3">
                  <div class="font-title">Nome Funcionário</div>
                  <autocomplete-z
                      v-if="isEdit === true && IsExterno === false"
                      ref="responsavelTypeahead"
                      placeholder="Informe o nome do funcionário"
                      type="text"
                      :serializer="(responsavel) => responsavel.nome"
                      :formField="form.ResponsavelId"
                      v-on:search="onSearchResponsavel"
                      :ShowCode="false"
                      />
                  <b-input
                    v-else-if="isEdit == true && !IsExterno"
                    :disabled="isEdit === false && IsExterno"
                    :style="isEdit === false ? 'cursor: not-allowed; background-color: #ebebeb; color: grey' : 'cursor: auto;'"
                    v-model="detalhes.nomeFuncionario"></b-input>
                  <b-input
                    v-else
                    :disabled="isEdit === false && IsExterno"
                    :style="isEdit === false ? 'cursor: not-allowed; background-color: #ebebeb; color: grey' : 'cursor: auto;'"
                    v-model="detalhes.nomeAssinatura"></b-input>
                </div>
              </div>
            </div>
            <div class="comprovante-container">
              <object class="img-container" >
                <div class="d-flex flex-column">
                    <img
                    class="signature-overview"
                    :src="`${`data:image/${type}`};base64,`+ midiapdf">
                </div>
                </object>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'
import { loading, toast } from '@/shared/utils/UIHelper'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'

export default {
  name: 'signatureQma',
  mixins: [ActionsForm, ExpenseMixin],
  components: {HeadDetailsGama, AutocompleteZ},
  data () {
    return {
      colunas: ['NOME', 'CARGO', 'DATA ASSINATURA', ''],
      dataSignature: [],
      formSearch: {},
      columTemplate: ['Atividades'],
      type: null,
      midiapdf: null,
      index: null,
      detalhes: {},
      originalDetails: {},
      form: {
        ResponsavelId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      isEdit: false,
      IsExterno: false,
      idQma: null
    }
  },

  props: ['propQma', 'qma'],

  watch: {
    'form.ResponsavelId.code' (newValue) {
      if (this.form.ResponsavelId.code !== null) {
        this.detalhes.matricula = newValue
      }
    },
    'form.ResponsavelId.value' (newValue) {
      if (this.form.ResponsavelId.value !== null) {
        this.detalhes.funcionarioId = newValue
      }
    }
  },

  mounted () {
  },
  methods: {
    onSelect (collabId) {
      // this.$router.push(`/APR/Consulta/Detalhes/`)
    },
    onLoad (value) {
      const params = new URLSearchParams(window.location.search)
      params.forEach((value) => {
        this.idQma = value
      })
      loading.push()
      inqueryQmaRepository.getSignatureQma(this.idQma, this.$refs.tableSignatureQma.pagingLimit, this.$refs.tableSignatureQma.pagingIndex)
        .then(Response => {
          this.dataSignature = Response.data.data
          this.$emit('dataSignature', this.dataSignature)
          this.$refs.tableSignatureQma.LoadAllByData(Response)
          loading.pop()
        })
        .catch(() => {
          loading.pop()
        })
    },
    openPopUpSignature (value) {
      this.posicao = null
      this.isEdit = false
      this.detalhes = {}
      this.posicao = this.dataSignature.findIndex(item => item.assinaturaID === value.assinaturaID)
      this.detalhes = this.dataSignature[this.posicao]
      if (this.originalDetails === null) {
        this.originalDetails = { ...this.detalhes }
      }
      this.verificaEdicao()
      this.getSignature(value.urlAssinatura)
      this.$refs['assinatura-render'].show()
    },
    cancel () {
      this.$refs['assinatura-render'].hide()
    },
    getSignature (obj) {
      loading.push()
      inqueryQmaRepository.getSignatureQmaUrl(obj)
        .then((Response) => {
          this.midiapdf = Response.data.data
          loading.pop()
        })
        .catch(() => {
          loading.pop()
        })
    },
    clickEdit () {
      this.isEdit = !this.isEdit
    },
    saveEdit () {
      this.detalhesEditado = {...this.detalhes}
      const ExecutanteEdit = {
        ID: this.detalhesEditado.id,
        DataAssinatura: this.detalhesEditado.DataAssinatura,
        DataAssinaturaFormatada: this.detalhesEditado.DataAssinaturaFormatada,
        DataAssinaturaFormatadaDia: this.detalhesEditado.DataAssinaturaFormatadaDia,
        TipoExecutante: this.detalhesEditado.tipoExecutante,
        TipoExecutanteDescricao: this.detalhesEditado.tipoExecutanteDescricao,
        NomeFuncionario: this.detalhesEditado.nomeFuncionario !== null ? this.detalhesEditado.nomeFuncionario : this.detalhesEditado.nomeAssinatura,
        funcionarioId: this.detalhes.externo === false && this.detalhes.offline === false ? this.form.ResponsavelId.value : this.detalhesEditado.funcionarioId,
        AssinaturaID: this.detalhesEditado.qmaAssinaturaId,
        AssinaturaStatus: this.detalhesEditado.AssinaturaStatus,
        AssinaturaStatusDescricao: this.detalhesEditado.AssinaturaStatusDescricao,
        NomeAssinatura: this.detalhesEditado.nomeAssinatura,
        Documento: this.detalhesEditado.documento,
        DocumentoAssinatura: this.detalhesEditado.documentoAssinatura,
        externo: this.detalhesEditado.externo,
        img64: null,
        matricula: this.detalhesEditado.matricula,
        urlImagem: this.detalhes.urlAssinatura
      }
      inqueryQmaRepository.EditInfoAssinaturaQma(ExecutanteEdit)
        .then(Response => {
          loading.pop()
          toast.success('Informações editadas com êxito!')
          this.$refs['assinatura-render'].hide()
          this.onLoad()
          this.isEdit = !this.isEdit
        })
        .catch(err => {
          console.log(err)
          loading.pop()
          toast.warning('Erro ao alterar informações do funcionário!')
        })
      loading.push()
    },
    close () {
      this.isEdit = !this.isEdit
      this.detalhes = this.originalDetails
      this.$refs['assinatura-render'].hide()
    },
    verificaEdicao () {
      this.IsExterno = false
      if (this.detalhes.externo === true) {
        this.IsExterno = true
      } else {
        this.IsExterno = false
      }
    },
    verificaCamposEdit () {
      if (this.IsExterno === false) {
        if (this.form.ResponsavelId.value == null) {
          toast.warning('Campos não podem ser nulos!')
        } else {
          this.saveEdit()
        }
      }
      if (this.IsExterno === true) {
        if (this.detalhes.nomeAssinatura === null ||
          this.detalhes.nomeAssinatura === '' ||
          this.detalhes.documentoAssinatura == null ||
          this.detalhes.documentoAssinatura === '') {
          toast.warning('Campos não podem ser nulos!')
        } else {
        }
      }
    }
  }
}

</script>

<style scoped>
.signature-overview{
  max-height: 35rem;
}
.edit-save {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.font-title, .font-info{
  font-size: 14px;
}
.font-title{
  font-weight: bold;
  color:#008144;
}

.nameSignature, .docSignature{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-family: 'Segoe UI';
  font-size: 14px;
}

.infoSingature {
  background-color: #f3f1f1;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  margin-bottom: 1rem;
}
.header-apr {
    background-color: white;
    height: 100%;
}
#impor-ex-price{
display: none;
}
.novoTemplate {
    padding: 0.5rem 3rem 0.5rem 3rem
}
.descricaoArea{
    width: 100%;
    height: 5rem;
    border-color: #b3b3b3;
    border-radius: 1px;
}
.header-title{
color: white;
font-weight: bold;
font-size: 16px;
font-family: 'Segoe UI';
}
.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 4px;
    border: none;
    font-size: 12px;
}
.btn-generate-lote:hover{
    background: #024d2a;
}
.button-cancel,
.button-save{
margin-top: 10;
font-size: 12PX;
outline: transparent;
border: transparent;
border-radius: 4px;
text-transform: uppercase;
width: 190px;
height: 40px;
}

.container_cancel_save{
justify-content: center;
width: 100%;
margin-top: 1.5rem;
column-gap: 10px;
}
.button-save{
background-color: darkgreen;
color: white;
}
.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
  }

  .header {
    display: flex;
    flex-wrap: wrap;
    color: white;
    justify-content: space-between;
    align-items: center;
    width:100%;
  }

  .button-modal {
  position: absolute;
    align-items: center;
    right: 0px;
}

.btn-header {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  .btn-repappr{
    gap: 1rem;
  }
  .btn-appr-rep {
  display: flex;
  justify-content: space-around;
  font-family: 'Segoe UI';
}
.btn-rep-popup{
    width: 10vw;
    background: red;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    height: 2rem;
    font-size: 14px;
  }
.btn-appr-popup{
    width: 10vw;
    height: 2rem;
    background: #008144;;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    font-size:14px
}

.btn-appr-popup-disabled{
    width: 10vw;
    height: 2rem;
    background-color: #D8D8D8;;
    color: #636363;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    font-size:14px
}
.btn-edit{
  color: #008144;
  font-weight: bold;
  font-family: 'Segoe UI';
  font-size: 14px;
  display: flex;
  align-items: center;
  width: 15%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/details/signatureQma/signatureQma.vue